export interface IOtpAuthSetup {
  secret: string;
  qrCode: string; // base64
}

export interface IOtpAuthResponse {
  access_token: string;
  otp_required: boolean;
}

export enum OtpAuthModeEnum {
  verification = 'verification',
  recovery = 'recovery',
}

export enum PasswordResetTokenStatusEnum {
  valid = 'valid',
  expired = 'expired',
  invalid = 'invalid',
}

export interface IPasswordResetCheck {
  status: PasswordResetTokenStatusEnum;
  otp_required: boolean;
}

export enum ResetPasswordStepEnum {
  loading = 'loading',
  invalidLink = 'invalidLink',
  form = 'form',
  success = 'success',
}
